import { Reducer } from "../../lib/redux";
import { extend } from "../../utils/vanilla";
import { ErrorActions } from "./actions";
import { ErrorActionTypes, IError } from "./types";


export let error: Reducer<IError, ErrorActions> = (state: IError = {}, action): IError => {
    switch (action.type) {
        case ErrorActionTypes.SET_OFFLINE_ERROR:
            return {
                ...state,
                offlineError: extend(true, {}, action.payload)
            };
        case ErrorActionTypes.CLEAR_OFFLINE_ERROR:
            return {};
        default:
            return state;
    }
};